import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '@portals/core';
import { environment } from '@portals/environments';

@Component({
	selector: 'app-action-dialog',
	templateUrl: './action-dialog.component.html',
	styleUrls: ['./action-dialog.component.scss'],
})
export class ActionDialogComponent extends BaseComponent {
	app = environment.app;
	closeButton = true;
	denyButton = false;
	constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
		super();
		this.data.hasOwnProperty('closeButton') ? (this.closeButton = this.data.closeButton) : (this.closeButton = true);
		this.data.hasOwnProperty('denyButton') ? (this.denyButton = this.data.denyButton) : (this.denyButton = false);
	}
}
